module.exports = __webpack_public_path__ + "static/img/dianshang.42f77eb7.png";